module.exports = __webpack_public_path__ + "static/img/confirmationCorp.c05983f0.png";